import { store } from '@redux/store';
import { facetsReducers, searchParametersReducers } from 'features/searchResultsFacets';
import { createMap } from 'features/searchResultsMap';
import PaginationBar from './components/pagination/paginationBar';

require('features/speedcurve');
require('./components/eventTracking/speedcurveEventsHandler');

store.injectReducer('searchParameters', searchParametersReducers);
store.injectReducer('facetsState', facetsReducers);

createMap();

require('./analytics/uiUpdates');
require('./components/images/handlerErrorImages');
require('features/searchBar');
require('./components/searchBarInitializer');
require('features/leadGenerators');
require('features/searchResultsExtendedCard');
require('features/routing');
require('./components/facets');
require('./components/viewToggler');
require('./components/standardCard');
require('./components/summaryCard');
require('features/locationContent');
require('./components/formCertifier');
require('./routing');
require('./services/contentTemplateTypeHandler');
require('./components/resultTypeTabs');
require('./components/skeletonHandler');
require('./components/popularSearchesPillsHandler');
require('./components/builderDirectory/builderBrandCard');
require('./analytics/analyticsDimensions');
require('./components/containerUiUpdater');
require('./analytics/facets');
require('./analytics/favorites');
require('./analytics/pagination');
require('./analytics/phoneEventListener');
require('./analytics/schedulerEventListener');
require('./analytics/thankYouEventListener');
require('./components/header/hamburgerMenu');
require('features/segment');
require('./components/eventTracking/segmentEventsHandler');
require('features/googleAnalytics4');
require('./components/eventTracking/googleAnalytics4EventsHandler');
require('features/trackingProperties');
require('./components/backToTopHandler'); // TODO : Remove this - NHSRB-324
require('./components/backForwardHandler');
require('./components/geoProximityHandler');
require('./redux/listeners');
require('./components/noResults/noResultsClearButton');
require('./components/noResults/hintsSection');
require('features/googleAds');
require('./components/eventTracking/googleAdsEventsHandler');
require('./components/resultsLazyLoader');
require('./components/priceHighLink');
require('./components/listViewHandler');
require('./components/nativeAdsLoader');
require('./components/filterPanel');
require('features/savedSearch');
require('./components/sortingModalManager');

(() => new PaginationBar())();